﻿import React from 'react';

import { SkillTreeLegend } from 'pages/reports/components/SkillTree/SkillTree';
import { GMetrixTable } from 'components/GMetrixTable/GMetrixTable';
import { Report, ReportComponent } from 'apis/ReportApi';
import { Col, Row } from 'react-bootstrap';

type ScrollMode = 'scrollable' | 'none' | 'virtual';

interface TableGenericProps {
    allowExport?: boolean;
    component: ReportComponent;
    index: number;
    isSubReport?: boolean;
    loading: boolean;
    scrollable?: ScrollMode;
    setCurrentSubReport: (report: Report | undefined) => void;
}

export const TableGeneric = ({
    allowExport = true,
    component,
    index,
    isSubReport = false,
    loading,
    setCurrentSubReport
}: TableGenericProps) => (
    <>
        {!loading ? (
            component.Results && component.Results.Columns && component.Results.Data && (
                <>
                    {component.ConvertToFlatList &&
                        <SkillTreeLegend />
                    }
                    <Col
                        className={`component-wrapper__col ${isSubReport && 'rounded-0'}`}
                        key={`${component.ComponentId}-${index}`}
                        lg={isSubReport ? 12 : component.WidthLg}
                        md={isSubReport ? 12 : component.WidthMd}
                        sm={isSubReport ? 12 : component.WidthSm}
                        xl={isSubReport ? 12 : component.WidthXl}
                        xxl={component.WidthXl}
                    >
                        <GMetrixTable
                            allowExport={allowExport}
                            columnData={component.Results.Columns.filter(col => col.dataType !== 'Hidden')}
                            excelExportFileName={component.Title || 'ReportTable'}
                            exportContext="Report"
                            key={`${component.ComponentId}-${index}`}
                            lockColumns={true}
                            rowData={component.Results.Data}
                            setCurrentSubReport={setCurrentSubReport}
                            style={{ fontSize: component.HeaderStyles, maxWidth: '100%', overflowX: 'auto' }}
                        />
                    </Col>
                </>
            )
        ) : (
            <Col key={`${component.ComponentId}-${index}`}>
                <Row className="gray py-3"></Row>
                <Row className="skeleton py-5"></Row>
                <Row className="skeleton py-5"></Row>
                <Row className="skeleton py-5"></Row>
                <Row className="skeleton py-5"></Row>
                <Row className="gray py-3"></Row>
            </Col>
        )}
    </>
);
